module.exports = __webpack_public_path__ + "static/media/globe.e3277a64.svg";